export default __webpack_public_path__ + "static/B26-0f1767c2a71b9b045cbab8ab985901bd.png";